import {
  UPDATE_ORGANIZATION_INFO,
} from '../../types';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  updateOrganizationInfo,
  updateOrganizationInfoPending,
  updateOrganizationInfoFulfilled,
  updateOrganizationInfoRejected,
} = createAsyncActions(UPDATE_ORGANIZATION_INFO, 'updateOrganizationInfo');



// WEBPACK FOOTER //
// ./src/features/organization/actions/updateActions/updateOrganizationInfoActions.js